'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import StarknetWalletConnector from '../starknetWalletConnector.js';

class ArgentX extends StarknetWalletConnector {
    constructor(opts) {
        super('Argent X', 'argentX', opts);
        this.overrideKey = 'argentx';
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = yield this.getAddress();
            if (!address)
                return [];
            return [address];
        });
    }
}

export { ArgentX };
